'use strict';

module.exports = function(obj, prop){
	return Object.prototype.hasOwnProperty.call(obj, prop)
}



//////////////////
// WEBPACK FOOTER
// ./~/react-style-normalizer/src/hasOwn.js
// module id = 3750
// module chunks = 0